import { useState } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import dynamic from 'next/dynamic';

// Hooks
import useUser from '@/utils/hooks/swr/useUser';

import useLabelsAlbumsOnMedia from '@/utils/hooks/utils/useLabelsAlbumsOnMedia';

// Lib
import { POST, SQUARE, STORY } from '@/lib/posts/postTypes';

// Components
import ApplyGlobalStoreDates from '@/components/pages/myprofile/ApplyGlobalStoreDates';
import ErrorPostsListFallback from '@/components/pages/myprofile/ErrorPostsListFallback';
import FiltersSide from '@/components/pages/myprofile/filters/FiltersSide';
import PostsList from '@/components/pages/myprofile/PostsList';
const ExportXlsPostsModal = dynamic(
    () => import('@/components/pages/myprofile/modals/ExportXlsPostsModal')
);

const PostsTab = ({
    isFiltersOpen,
    toggleFilters,
    isExportModalOpen,
    toggleExportModal,
    activeSocialProfile,
    dataMedias,
    isLoadMore,
    isLoadingMore,
    isLoadingInitialData,
    requestParams,
    setRequestParams,
    mutateMedias,
    loadMoreMedia,
    postFormat = SQUARE,
    postType = POST,
    exportType = POST,
    renderFilters,
    header
}) => {
    const { user } = useUser();
    const [resetFilters, setResetFilters] = useState(false);

    const { handleAlbumsEvent, handleLabelsEvent } = useLabelsAlbumsOnMedia({
        mutateMedias,
        requestParams,
        type: postType !== STORY ? 'medias' : 'stories'
    });

    return (
        <>
            <ApplyGlobalStoreDates setRequestParams={setRequestParams} />
            <ExportXlsPostsModal
                isOpen={isExportModalOpen}
                toggle={toggleExportModal}
                requestParams={requestParams}
                postType={postType}
                exportType={exportType}
            />

            <div className="z-0 flex flex-1 flex-col @xl/wrapper-platform-content:flex-row">
                <div className="flex flex-1 flex-col">
                    {header ? header(setRequestParams, postType) : null}
                    <ErrorBoundary
                        FallbackComponent={ErrorPostsListFallback}
                        onReset={() => mutateMedias()}>
                        <PostsList
                            type={postType !== STORY ? 'medias' : 'stories'}
                            configPost={{
                                postFormat: postFormat,
                                postType: postType,
                                activeFilter: requestParams?.sort?.column ?? null,
                                network: activeSocialProfile,
                                numberFormat: user?.settings.numbers_format
                            }}
                            displayDates={
                                requestParams && requestParams?.sort?.column === 'created'
                            }
                            mutateMedias={mutateMedias}
                            isLoadMore={isLoadMore}
                            isLoadingMore={isLoadingMore}
                            loadMoreMedia={loadMoreMedia}
                            dataMedias={dataMedias}
                            requestParamsMedias={requestParams}
                            isFiltersOpen={isFiltersOpen}
                            isLoadingInitialData={isLoadingInitialData}
                            handleLabelsEvent={handleLabelsEvent}
                            handleAlbumsEvent={handleAlbumsEvent}
                            hasPendoCoreEvent
                        />
                    </ErrorBoundary>
                </div>
                {renderFilters ? (
                    <FiltersSide
                        isOpen={isFiltersOpen}
                        onResetFilters={() => setResetFilters(true)}
                        toggleFilters={toggleFilters}>
                        {renderFilters(resetFilters, setResetFilters)}
                    </FiltersSide>
                ) : null}
            </div>
        </>
    );
};

export default PostsTab;
